const constants = {
    SUCCESS_MSG: 'Your order has been placed successfully!',
    THANKYOU_MSG: 'Thank you for shopping with us',
}
export default constants;